export const CARD_EVENTS = {
  card: {
    CARD_AUTH_START: 'CARD_AUTH_START',
    CARD_AUTH_ABORT: 'CARD_AUTH_ABORT',
    CARD_AUTH_FINISH: 'CARD_AUTH_FINISH',
    CARD_AUTH_FORM_START: 'CARD_AUTH_FORM_START',
    CARD_AUTH_FORM_FINISH: 'CARD_AUTH_FORM_FINISH',
  },
};
